import { render, staticRenderFns } from "./DocumentTopBar.vue?vue&type=template&id=5fb33f84&scoped=true&"
import script from "./DocumentTopBar.vue?vue&type=script&lang=js&"
export * from "./DocumentTopBar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=5fb33f84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb33f84",
  null
  
)

export default component.exports